import $ from 'jquery';
import _ from 'lodash';
import tectoastr from '@/lib/tectoastr';

import 'datatables.net';
import 'datatables.net-colreorder';
import 'datatables.net-responsive';

/**
 * DataTable - responsive tables with support for column reordering.
 *
 * http://datatables.net/
 *
 * Usage:
 *   const datatable = new DataTable();
 *   datatable.setup(table);
 *
 */
export default class DataTable {
	/**
	 * Table element
	 */
	table;

	/**
	 * DataTable
	 */
	datatable;

	/**
	 * Area
	 */
	area;

	/**
	 * Return column definitions
	 *
	 * https://datatables.net/reference/option/columnDefs
	 *
	 * @param {jQuery} headers
	 * @return {Array}
	 */
	getColumnDefs(headers) {
		return _.map(headers, function (th, i) {
			th = $(th);

			return {
				targets: i,
				width: th.data('fixed') ? '1%' : null,
			};
		});
	}

	/**
	 * Calculate the number of fixed columns
	 *
	 * https://datatables.net/reference/option/colReorder.fixedColumnsLeft
	 */
	getFixedColumnsLeft(headers) {
		return _.reduce(
			headers,
			function (memo, th) {
				return memo + ($(th).data('fixed') ? 1 : 0);
			},
			0
		);
	}

	reorderCallback = () => {
		const columns = [];

		this.table.find('th').each(function (index, th) {
			columns.push($(th).data('name'));
		});

		$.ajax({
			type: 'POST',
			url: '/search/columns/order',
			data: {
				area: this.area,
				columns: columns,
			},
		}).fail(function () {
			tectoastr.error($('#alerts-column-order').text());
		});
	};

	/**
	 * Prevent checkbox input from expanding hidden column details
	 */
	blockCheckboxInput(table) {
		table.find('td:first-child input[type="checkbox"], td:first-child .checkbox').click(function (event) {
			event.stopPropagation();
		});
	}

	removeEvents() {
		$(window).off('slidein', this.refresh);
		this.table.off('column-reorder.dt', this.reorderCallback);
	}

	preInit() {
		if (!this.datatable) {
			return;
		}

		this.datatable.destroy();
		this.datatable = null;
		this.removeEvents();
	}

	refresh = () => {
		if (!this.datatable) {
			return;
		}

		this.datatable.responsive.rebuild();
		this.datatable.responsive.recalc();
	};

	setup(element) {
		this.table = typeof element !== 'string' && element instanceof $ ? element : $(element);

		if ($.fn.DataTable.isDataTable(this.table)) {
			return;
		}

		this.preInit();
		this.area = this.table.data('area');

		const headers = this.table.find('th');
		const fixedColumns = this.getFixedColumnsLeft(headers);
		const columnDefs = this.getColumnDefs(headers);

		this.datatable = this.table.DataTable({
			colReorder: {
				realtime: false,
				fixedColumnsLeft: fixedColumns,
			},
			autoWidth: false,
			bPaginate: false,
			bInfo: false,
			searching: false,
			bSort: false,
			responsive: true,
			columnDefs: columnDefs,
		});

		$(window).on('slidein', this.refresh);
		this.table.on('column-reorder.dt', this.reorderCallback);

		this.blockCheckboxInput(this.table);
	}
}
